import type { RouteLocationNormalizedLoaded } from 'vue-router';

const CONNECTED_AREA_PREFIX = '/backoffice';

type ScrollTargetRoute = Pick<RouteLocationNormalizedLoaded, 'path' | 'hash'>;

export const appScrollBehavior = (to: ScrollTargetRoute) => {
  if (to.hash) {
    return { el: to.hash };
  }

  if (to.path.startsWith(CONNECTED_AREA_PREFIX)) {
    return { left: 0, top: 0 };
  }

  return false;
};
